import actions from '../../actionTypes';

export default email => {
  return {
    type: actions.CREATED_ACCOUNT,
    email
  };
};



// WEBPACK FOOTER //
// ./src/reducers/auth/actions/createdAccount.js